const styles = theme => ({
  customDomain__root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 16,
  },
  embedInstructionText: {
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'Inter',
  },
  pdfContainer: {
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '120px',
    minWidth: '100%',
    borderRadius: '12px',
    backgroundColor: '#F4F6F8',
    flexDirection: 'column',
  },
  badge: {
    display: 'flex',
    height: '20px',
    borderRadius: '5px',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '5px',
    marginTop: '3px',
    backgroundColor: '#015ffb14',
    width: '60px',
  },
  fileName: {
    fontSize: 14,
    fontWeight: 400,
    fontFamily: 'Inter',
    textAlign: 'center',
    margin: '8px 0',
  },
  fileSize: {
    fontSize: 12,
    fontWeight: 400,
    fontFamily: 'Inter',
    color: '#919EAB',
  },
  downloadButton: {
    padding: '8px 16px',
    backgroundColor: '#015FFB',
    color: 'white',
    borderRadius: '8px',
    textAlign: 'center',
    width: '100%',
    textDecoration: 'none',
    display: 'inline-block',
    marginTop: '16px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#015FFB',
    },
  },
  pdfIcon: {
    width: '36px',
    height: '36px',
  },
})

export default styles
